import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './oem_user_confirm.routes';
import OemUserConfirmService from '../../components/api/oem_user_confirm/oem_user_confirm.service';

export class OemUserConfirmController {
  /*@ngInject*/
  constructor($state, $mdDialog, $stateParams, OemUserConfirmService) {
    this.OemUserConfirmService = OemUserConfirmService;
    this.query = {token: $stateParams.token};
    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.dialogs = {
      error: $mdDialog.alert({
        disableParentScroll: false,
        title: 'パスワードの設定に失敗しました',
        content: '時間を置いて再試行しても解決しない場合は、IIJサポートセンターにお問い合わせください。',
        ok: 'OK'
      }),
      success: $mdDialog.alert({
        disableParentScroll: false,
        title: 'パスワードの設定が完了しました',
        content: 'ログインページに移動します',
        ok: 'OK'
      })
    };
  }

  $onInit() {
  }

  submitConfirm() {
    this.OemUserConfirmService.api.update(
      this.query,
      res => {
        this.$mdDialog.show(this.dialogs.success).finally(() => this.$state.go('oem_login'));
      },
      err => {
        if(err.data.message === 'wrong token') {
          this.dialog.error.content('パスワード設定用URLが無効です');
        }
        this.$mdDialog.show(this.dialogs.error);
      }
    );
  }
}

export default angular.module('leptonApp.oemUserConfirm', [uiRouter, OemUserConfirmService])
  .config(routing)
  .component('oemUserConfirm', {
    template: require('./oem_user_confirm.html'),
    controller: OemUserConfirmController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/oem_user_confirm/oem_user_confirm.component.js